// src/utils/audioFolder.js

// List of files you ACTUALLY have in audio/podcasts/
const EXISTING_FILES = [
  "ai-arms-race.mp3", "ai-creative-copilot.mp3", "ai-ethics-bias.mp3",
  "ai-healthcare.mp3", "ai-revolution.mp3", "broadway-high-stakes-magics.mp3",
  "creative-genealogy.mp3", "creator-economy.mp3", "de-influencing.mp3",
  "digital-alchemy-hit-records.mp3", "digital-marketing-mastery.mp3",
  "digital-minimalism.mp3", "esg-investing.mp3", "financial-therapy.mp3",
  "franchise-model.mp3", "future-of-search.mp3", "hacking-creativity-code.mp3",
  "lab-grown-meat.mp3", "lazy-girl-job.mp3", "marketing-roi.mp3",
  "movie-popcorn-science.mp3", "mrna-revolution.mp3", "neural-networks-advanced.mp3",
  "nutrition-science.mp3", "one-person-business.mp3", "pink-collar-recession.mp3",
  "platonic-breakup.mp3", "productivity-systems.mp3", "psychedelic-renaissance.mp3",
  "quantum-computing.mp3", "react-architecture.mp3", "secret-math-high-growth-startups.mp3",
  "soft-life.mp3", "space-tech.mp3", "spatial-computing.mp3",
  "startup-failures.mp3", "sustainable-business.mp3", "synthetic-media.mp3",
  "uncanny-valley.mp3", "viral-hit-anatomy.mp3", "web-development-2026.mp3",
  "weight-loss-drugs.mp3","de-amazonification.mp3"
];

// Simple check: is this filename in our list?
export function hasAudioFile(filename) {
  if (!filename) return false;
  return EXISTING_FILES.includes(filename);
}

// Get all files
export function getAudioFiles() {
  return EXISTING_FILES;
}

// When you add a new file, just add it to the array above